module.exports = __webpack_public_path__ + "img/fixtureAmer20.5fdaeaf9.jpg";